<template>
  <div class="report-actions" v-if="hasActions">
    <dropdown-menu-button
      :disabled="menuDisabled"
      :loading="loading"
      icon-color="light"
      :dark="false"
      :icon-button="false"
      :fab-button="false"
      size="default"
      buttons-class="no-min-width"
    >
      <v-list>
        <v-list-item
          v-for="(action, key) in actions"
          :key="key"
          @click="handleAction(key, action)"
        >
          <v-list-item-title :class="{ 'red--text': action.destructive }">
            {{ action.label }} ({{ selectedCount }})
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </dropdown-menu-button>

    <v-dialog v-model="resultDialog" max-width="480px" :retain-focus="false">
      <modal-card
        :title="actionResult.success ? 'Action Complete' : 'Action Failed'"
        @close="resultDialog = false"
        :full="!actionResult.url"
      >
        <div class="pa-6 pt-8 pb-8 text-center">
          <v-icon
            :color="actionResult.success ? 'success' : 'error'"
            size="48"
            class="mb-4"
          >
            {{ actionResult.success ? 'check_circle' : 'error' }}
          </v-icon>
          <p class="text--secondary mb-0">{{ actionResult.message }}</p>
        </div>

        <template v-if="actionResult.url" v-slot:actions>
          <v-btn color="appMain" :href="actionResult.url" target="_blank">
            <v-icon left>open_in_new</v-icon>
            {{ actionResult.urlText }}
          </v-btn>
        </template>
      </modal-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'ReportActions',

  props: {
    report: {
      type: Object,
      default: () => ({}),
    },
    selectedRows: {
      type: Array,
      default: () => [],
    },
    params: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      loading: false,
      resultDialog: false,
      actionResult: {},
    };
  },

  computed: {
    actions() {
      return this.report?.actions || {};
    },
    hasActions() {
      return Object.keys(this.actions).length > 0;
    },
    selectedCount() {
      return this.selectedRows.length;
    },
    menuDisabled() {
      return !this.selectedRows.length;
    },
    rowKey() {
      return this.report?.row_key || 'id';
    },
  },

  methods: {
    ...mapActions('reports', ['runAction']),

    handleAction(actionKey, action) {
      const execute = () => this.executeAction(actionKey);

      if (action.confirm) {
        this.openConfirmationModal({
          text:
            action.confirm_text ||
            `Are you sure you want to run "${action.label}"?`,
          onConfirm: execute,
        });
      } else {
        execute();
      }
    },

    resultFromResponse(
      { message, url, url_text } = {},
      fallbackMessage,
      success
    ) {
      return {
        success,
        message: message || fallbackMessage,
        url: url || '',
        urlText: url_text || 'Open',
      };
    },

    async executeAction(actionKey) {
      this.loading = true;
      const rowKeys = this.selectedRows.map((row) => row[this.rowKey]);

      try {
        const result = await this.runAction({
          reportId: this.report.id,
          actionKey,
          rowKeys,
          params: this.params,
        });
        this.actionResult = this.resultFromResponse(
          result,
          'Action completed',
          true
        );
        this.$emit('action-complete');
      } catch (e) {
        this.actionResult = this.resultFromResponse(
          e?.response?.data,
          'Action failed',
          false
        );
      } finally {
        this.loading = false;
        this.resultDialog = true;
      }
    },
  },
};
</script>
